import type { Tone } from '../api/types'

/** "Today" / "Tomorrow" / "3d overdue" / "Sep 15", with the tone the design uses:
 *  danger when overdue, warning due today, neutral otherwise. */
export function dueLabel(iso: string | null, done = false): { text: string; tone: Tone } {
  if (!iso) return { text: 'No due date', tone: 'neutral' }
  const due = new Date(iso)
  if (Number.isNaN(due.getTime())) return { text: '—', tone: 'neutral' }
  const startOf = (d: Date) => new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime()
  const days = Math.round((startOf(due) - startOf(new Date())) / 86_400_000)
  const date = due.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })
  if (done) return { text: date, tone: 'neutral' }
  if (days < 0) return { text: `${-days}d overdue`, tone: 'danger' }
  if (days === 0) return { text: 'Today', tone: 'warning' }
  if (days === 1) return { text: 'Tomorrow', tone: 'neutral' }
  return { text: date, tone: 'neutral' }
}

/** A date-input value (YYYY-MM-DD) for today + n days, in local time. */
export function dateInput(offsetDays = 0): string {
  const d = new Date()
  d.setDate(d.getDate() + offsetDays)
  const m = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  return `${d.getFullYear()}-${m}-${day}`
}
